<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      label-width="68px"
    >
      <el-form-item label="关键字" prop="key">
        <el-input
          v-model="queryParams.condition.key"
          placeholder="请输入关键字"
          clearable
          style="width: 240px"
        />
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      v-loading="loading"
      :data="userList"
      :row-style="{ height: '58px' }"
      height="calc(100vh - 300px)"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      border
    >
      <el-table-column
        label="任务编号"
        align="center"
        prop="taskNo"
        width="150"
        :show-overflow-tooltip="true"
      />
      <el-table-column label="任务名称" align="center" prop="taskName">
      </el-table-column>
      <el-table-column
        label="转单原由"
        align="center"
        prop="description"
        :show-overflow-tooltip="true"
      >
      </el-table-column>

      <el-table-column
        label="接收状态"
        align="center"
        prop="receiveStatus"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.receiveStatus === true
                ? 'success'
                : scope.row.receiveStatus === false
                ? 'danger'
                : 'info'
            "
            >{{
              scope.row.receiveStatus === true
                ? "成功"
                : scope.row.receiveStatus === false
                ? `失败【${scope.row.reason}】`
                : "待处理"
            }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        label="发起人"
        align="center"
        prop="transferName"
        width="180"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="接受人"
        align="center"
        prop="receiverName"
        width="180"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="操作"
        align="center"
        width="220"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            slot="reference"
            @click="handleAccept(scope.row)"
            >接 收</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.page"
      :limit.sync="queryParams.limit"
      :pageSizes="[50, 100, 200, 500]"
      @pagination="getList"
    />
  </div>
</template>
      
      <script>
import {
  postWorkTransferList,
  postWorkTransferAccept,
} from "@/api/work/OrderTaking";
export default {
  data() {
    return {
      userList: [],
      // 总条数
      total: 0,
      // 遮罩层
      loading: false,
      USER: {},
      // 非多个禁用
      multiple: true,
      queryParams: {
        limit: 50,
        page: 1,
        condition: {
          type: "2",
        },
        orderBy: "",
      },
      taskId: "", //任务id
    };
  },
  created() {
    this.getList();
    this.USER = JSON.parse(sessionStorage.getItem("user"));
  },
  methods: {
    /** 查询用户列表 */
    async getList() {
      this.loading = true;
      let { data } = await postWorkTransferList(this.queryParams);
      this.userList = data.records;
      this.total = data.total;
      this.loading = false;
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams.condition.key = undefined;
      this.getList();
    },
    /** 接收 */
    handleAccept(row) {
      this.$confirm("是否确认接收?", "提示", {
        distinguishCancelAndClose: true,
        cancelButtonText: "拒绝",
        confirmButtonText: "同意",
        type: "warning",
      })
        .then(async () => {
          let from = {
            taskId: row.taskId,
            receiveStatus: true,
            transferId: row.id,
          };
          let { code } = await postWorkTransferAccept(from);
          if (code === 200) {
            this.$message({
              message: "接收成功",
              type: "success",
            });
            this.getList();
          }
        })
        .catch(async (action) => {
          //跳转路由2，并且传参
          if (action === "cancel") {
            let from = {
              taskId: row.taskId,
              receiveStatus: false,
              transferId: row.id,
            };
            let { code } = await postWorkTransferAccept(from);
            if (code === 200) {
              this.$message({
                message: "拒绝成功",
                type: "success",
              });
              this.getList();
            }
          } else {
            //关闭弹窗
            return;
          }
        });
    },
  },
};
</script>
      
      <style>
</style>